export default {
  getSelections: ({ selections }) => selections,
  getDirection: ({ direction }) => direction,
  getSliders: ({ sliders }) => sliders,
  getLoadingStatus: ({ isLoading }) => isLoading,
  getRailPosition: ({ railPosition }) => railPosition,
  getLogInStatus: ({ isLoggedIn }) => isLoggedIn,
  getPresetData: state =>
    state.presetData.map(preset => ({
      ...preset,
      isSelected: preset.id === state.selectedPresetId,
    })),
  getShowModal: ({ showModal }) => showModal,
  getSelectedPresetId: ({ selectedPresetId }) => selectedPresetId,
};
